"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NutritionWeekOverview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const react_i18next_1 = require("react-i18next");
const typography_1 = require("../../shared/typography");
const Elements_1 = require("./Elements");
const hasCalorieBudgetInfo = (days) => {
    let hasBudgetInfo = false;
    days.forEach((day) => {
        if (day.calorieBudgetInfo) {
            hasBudgetInfo = true;
            return;
        }
    });
    return hasBudgetInfo;
};
exports.NutritionWeekOverview = (0, react_1.memo)(({ average, days, unit, onHeaderClick, budgetFactsMap }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(Wrapper, { children: [(0, jsx_runtime_1.jsx)(typography_1.H2, { onClick: onHeaderClick, "data-cy": "nutrition-overview-header", children: t("nutrition.weekOverview.title") }, void 0), (0, jsx_runtime_1.jsx)(Elements_1.Days, { days: days, unit: unit }, void 0), (0, jsx_runtime_1.jsx)(Elements_1.Average, { average: average, unit: unit, hasCalorieBudgetInfo: hasCalorieBudgetInfo(days) }, void 0), (0, jsx_runtime_1.jsx)(Elements_1.Budget, { budget: budgetFactsMap, unit: unit }, void 0)] }, void 0));
});
const Wrapper = styled_components_1.default.div `
  background-color: ${({ theme }) => theme.colors.whiteBase};
  border: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-radius: ${({ theme }) => theme.utils.radius};

  & div > p:last-of-type {
    margin-bottom: 0;
  }

  & > h2 {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
    cursor: pointer;
    line-height: ${({ theme }) => theme.spacings.xl};
    margin-bottom: 0;
    padding: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};
  }

  & > div {
    margin: ${({ theme }) => `${theme.spacings.m} ${theme.spacings.xl}`};

    & > div:not(:last-of-type) {
      margin-bottom: ${({ theme }) => theme.spacings.xs};
    }

    & > div:last-of-type {
      margin-bottom: ${({ theme }) => theme.spacings.m};
    }
  }

  & > div:not(:last-of-type) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.silverLighten70};
  }

  & > div:last-of-type > div > p {
    font-weight: 500;
  }
  
  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    & > h2 {
      padding: ${({ theme }) => theme.spacings.m};
    }
  
    & > div {
      margin: ${({ theme }) => theme.spacings.m};
  }
`;
//# sourceMappingURL=index.js.map